<template>
  <div class="addwork">
    <communityHeader :router_url="router_url"></communityHeader>

    <div class="contentWidth" id="contentWidth">
      <div class="location">
        <span>当前位置：中经视觉社区</span>><span>发表新作品</span>
      </div>
      <div class="of_h">
        <div class="right fc_r" id="right">
          <div class="pd_15 fl">
            <div class="title">分类</div>
            <div class="entry">
              <el-select
                v-model="topicWork.topic.forumId"
                style="width: 100%"
                placeholder="请选择"
              >
                <el-option
                  v-for="(item, index) in options"
                  :key="index"
                  :label="item.forumName"
                  :value="item.forumId"
                >
                </el-option>
              </el-select>
            </div>
            <div class="title mt_20">标签</div>
            <div class="entry">
              <el-input
                class="fc_l"
                style="width: 320px"
                v-model="entrytag"
                @keyup.enter.native="addtag"
                placeholder="填写5个以上描述图片的关键字..."
              ></el-input>
              <img
                class="fc_l"
                src="../../../assets/image/community/addtsg.png"
                @click="addtag()"
              />
            </div>
            <div class="tags">
              <el-tag
                style="margin: 10px 5px 0 0"
                v-for="(tag, index) in tags"
                :key="index"
                closable
                @close="handleClose(index)"
                :type="tag.type"
              >
                {{ tag.name }}
              </el-tag>
            </div>
            <p class="tips _width _height">
              提示：建议图片小于5MB，视频小于30MB。暂不支持图片和视频同时上传。
            </p>

            <div class="addworkbtn">
              <div class="of_h">
                <button
                  class="fc_l b1"
                  v-ripple="'rgba(255, 255, 255, 0.3)'"
                  @click="savework()"
                  type="button"
                >
                  发布
                </button>
                <button
                  class="fc_r b2"
                  v-ripple="'rgba(255, 0, 0, 0.3)'"
                  @click="backpege()"
                  type="button"
                >
                  取消
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="left of_h" id="left">
          <div class="entry mt_20">
            <input
              type="text"
              v-model="topicWork.topic.title"
              placeholder="添加标题"
            />
          </div>
          <div class="entry mt_20">
            <textarea
              v-model="topicWork.topic.description"
              placeholder="分享镜头背后的故事"
            ></textarea>
          </div>

          <div class="uploadfile mt_15 of_h">
            <button class="" v-ripple="'rgba(255, 0, 0, 0.2)'">
              <img src="../../../assets/image/community/uploadimg.png" />
              <input
                name="upfile"
                class="file-upload-input"
                id="upfileImg"
                multiple="multiplt"
                type="file"
                @change="uploadImg($event)"
              />
            </button>

            <button class="" v-ripple="'rgba(255, 0, 0, 0.2)'">
              <img src="../../../assets/image/community/uploadvideo.png" />
              <input
                name="upfile"
                class="file-upload-input"
                id="upfileVideo"
                type="file"
                @change="uploadvideo($event)"
              />
            </button>
          </div>

          <div class="files">
            <div
              class="box"
              v-for="(backimg, index) in topicWork.topicTnList"
              :key="index"
            >
              <div v-show="backimg.type == 1">
                <img :src="`${path}${backimg.tnUrl}`" />
                <div class="entry">
                  <textarea
                    v-model="backimg.description"
                    placeholder="写点什么..."
                  ></textarea>
                </div>
                <div class="deleteBtn" @click="delbackimg(index)">×</div>
              </div>

              <div v-show="backimg.type == 2">
                <video
                  :src="`${path}${backimg.topicUrl}`"
                  style="width: 600px"
                  controls="controls"
                ></video>
                <div class="entry">
                  <textarea
                    v-model="backimg.description"
                    placeholder="写点什么..."
                  ></textarea>
                </div>
                <div class="deleteBtn" @click="delbackimg(index)">×</div>
              </div>
            </div>
            <div class="box" v-show="loading">
              <loading></loading>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import communityHeader from "@/components/community/common/communityHeader.vue";
import loading from "@/components/loading/loading.vue";
import {
  NewTopicImg,
  NewTopicVideo,
  saveNewTopic,
  selectforums,
  deleteTopicImg,
} from "@/utils/api/addwork.js";
export default {
  name: "addwork",
  data() {
    return {
      loading: false,
      value: "",
      entrytag: "",
      backImgs: [],
      options: [],
      tags: [],
      topicWork: {
        circleId: "", //圈子id
        topic: {
          description: "", //作品描述
          hasImage: 0, //是否包含图片1：是，2：否
          hasVideo: 0, //是否包含视频1：是，2：否
          sortNo: 0, //排序号
          tags: "", //标签
          title: "", //作品标题
          forumId: "", //分类
          type: 0, //属于p还是移动端（1：pc）
        },
        topicTnList: [],

        img_data: [], //上传图片接口
        video_data: [], //视频接口
      },
      isDisable: true, //false 不可点击  true 可以点击
      path: this.URL.path,
      // path: 'https://v-pic.jingjiribao.cn',//拼接地址
    };
  },
  components: {
    communityHeader,
    loading,
  },
  created() {
    this.router_url = this.$route.fullPath; //当前地址url
    this.circleId = this.$route.params.id;
  },
  methods: {
    //获取分类
    getselectforums() {
      selectforums().then((res) => {
        this.options = res.data;
      });
    },
    // 上传图片事件
    uploadImg(event) {
      this.loading = true;

      // console.log(this.topicWork.topicTnList);
      // 判断视频是否已上传
      if (this.video_data !== undefined && this.video_data.length !== 0) {
        this.$message({
          message: "作品只能上传一种类型",
          center: true,
          type: "warning",
        });
        this.loading = false;
        return false;
      }
      let fileImgs = event.target.files;
      let formData = new FormData();

      // for (let i = 0; i < formData; i++) {
      //   console.log(i);
      // };
      for (let i = 0; i < fileImgs.length; i++) {
        formData.append("fileName", fileImgs[i]);
        let size = fileImgs[i].size;
        // console.log(size / (1024 * 1024));
        if (size / (1024 * 1024) >= 5) {
          this.$message({
            message: "上传的图片大小不能超过5MB",
            center: true,
            type: "warning",
          });
          this.loading = false;
          return false;
        }
      }

      this.postNewTopicImg(formData);
    },

    // 上传  视频事件
    uploadvideo(event) {
      // 判断图片是否已上传
      // if (this.img_data) {
      if (this.img_data !== undefined && this.img_data.length !== 0) {
        this.$message({
          message: "作品只能上传一种类型!",
          center: true,
          type: "warning",
        });
        return false;
      }
      console.log(this.topicWork);

      // 判断视频是否已上传
      if (this.topicWork.topicTnList.length !== 0) {
        this.$message({
          message: "只能上传一个视频哦！",
          center: true,
          type: "warning",
        });
        // this.postNewTopicvideo()
        this.loading = false;
        return false;
      }

      this.loading = true;
      let fileImgs = event.target.files[0];
      let formData = new FormData();
      formData.append("fileName", fileImgs);
      let size = fileImgs.size;
      // console.log(size / (1024 * 1024));
      if (size / (1024 * 1024) >= 30) {
        this.$message({
          message: "上传的视频大小不能超过30MB",
          center: true,
          type: "warning",
        });
        this.loading = false;
        return false;
      }

      this.postNewTopicvideo(formData);
    },

    //上传图片
    postNewTopicImg(imgFormData) {
      NewTopicImg({ data: imgFormData }).then((res) => {
        this.img_data = res.data;
        if (res.data.code == 200) {
          this.$message({
            message: "上传成功，可以继续上传了！",
            center: true,
            type: "success",
          });
          for (let i = 0; i < res.data.data.length; i++) {
            res.data.data[i].description = "";
            res.data.data[i].type = 1;
            this.topicWork.topicTnList.push(res.data.data[i]);
          }
          this.loading = false;
          this.topicWork.topic.hasImage = 1;
          //console.log(this.topicWork)
        } else {
          this.topicWork.topic.hasImage = 0;
          this.loading = false;
          this.$message({
            message: res.data.message,
            center: true,
            type: "error",
          });
        }
      });
    },

    //上传视频
    postNewTopicvideo(videoFormData) {
      NewTopicVideo({
        data: videoFormData,
      }).then((res) => {
        this.video_data = res.data;
        if (res.data.code == 200) {
          res.data.data.description = "";
          res.data.data.type = 2;
          this.topicWork.topicTnList.push(res.data.data);
          this.loading = false;
          this.$message({
            message: "上传成功，可以继续上传了！",
            center: true,
            type: "success",
          });
          this.topicWork.topic.hasVideo = 2;
          console.log(this.topicWork);
        } else {
          this.topicWork.topic.hasVideo = 0;
          this.loading = false;
          console.log(res.data);
          this.$message({
            message: res.data.message,
            center: true,
            type: "error",
          });
        }
      });
    },

    //添加标签
    addtag() {
      // if (this.entrytag) {
      //   this.tags.push({
      //     name: this.entrytag,
      //     type: 'info'
      //   });
      //   this.entrytag = ""
      let entrytag = this.entrytag;
      if (entrytag) {
        var values = entrytag.split(/[,， \n]/).filter((item) => {
          return item != "" && item != undefined;
        });
        values.forEach((element) => {
          var index = this.tags.findIndex((i) => {
            return i == element;
          });
          if (index < 0) {
            var arr = this.tags;
            for (var i = 0; i < arr.length; i++) {
              if (arr[i].name == element) {
                this.$message({
                  message: "不可以添加重复的标签哦！",
                  center: true,
                  type: "warning",
                });
                return false;
              }
            }
            console.log(this.tags.length);
            if (this.tags.length >= 20) {
              this.$message({
                message: "最多只能添加20个标签！",
                center: true,
                type: "warning",
              });
              return false;
            }

            this.tags.push({
              name: element,
              type: "info",
            });
            this.entrytag = "";
            // console.log(element);
            // console.log(this.dynamicTags);
          }
        });
      } else {
        this.$message({
          message: "请输入标签内容",
          center: true,
          type: "error",
        });
      }
    },
    //删除标签
    handleClose(index) {
      this.tags.splice(index, 1);
    },

    //标签处理
    topictags() {
      if (this.tags) {
        let temArr = [];
        let tagstring = "";
        for (let i = 0; i < this.tags.length; i++) {
          temArr.push(this.tags[i].name);
        }
        return (tagstring = temArr.join(","));
      }
    },
    //保存作品
    savework() {
      // 防止重复点击  时间1s
      // this.isDisable = true
      // setTimeout(() => {
      //   this.isDisable = false
      // }, 1000)

      this.topicWork.topic.tags = this.topictags();
      this.topicWork.circleId = this.$route.params.id; //圈子ID
      this.topicWork.topic.type = 1;
      this.topicWork.topic.sortNo = 0;
      this.topicWork.topic.title; //
      this.topicWork.topic.description;
      this.topicWork.topic.forumId;
      this.topicWork.topic.hasImage;
      this.topicWork.topic.hasVideo;

      if (
        this.topicWork.topic.title &&
        this.topicWork.topic.forumId &&
        this.topicWork.topicTnList.length > 0
      ) {
        saveNewTopic(this.topicWork).then((res) => {
          if (res.data.code == 200) {
            this.$message({
              message: "小伙伴辛苦啦！发布作品成功！",
              center: true,
              type: "success",
            });

            //  进入圈子最列表
            this.$router.push({
              path: "/circleDetail/" + this.topicWork.circleId,
            });
            this.topicWork.topic.title = "";
            this.topicWork.topic.forumId = "";
            this.topicWork.topic.tags = "";
            this.topicWork.topic.description = "";
            this.tags = [];
            this.topicWork.topicTnList = [];
            this.entrytag = "";
          }
        });
      } else {
        this.$message({
          message: "标题、分类不能为空，至少上传一张作品图片或者视频！",
          center: true,
          type: "warning",
        });
      }
    },
    //删除作品下图片
    delbackimg(index) {
      this.topicWork.topicTnList.splice(index, 1);
      this.$message({
        message: "刪除成功！",
        center: true,
        type: "success",
      });
    },
    backpege() {
      // 防止重复点击  时间1s
      this.isDisable = true;
      setTimeout(() => {
        this.isDisable = false;
      }, 1000);
      this.$router.push({
        path: "/circleDetail/" + this.circleId,
      });
    },
  },
  mounted() {
    this.getselectforums();
    // let winHeight = document.documentElement.clientHeight || document.documentElement.clientHeight;
    // let contentWidth = document.getElementById("contentWidth");
    // let left = document.getElementById("left");
    // let right = document.getElementById("right");
    // contentWidth.style.height = winHeight - 110 + "px";
    // left.style.height = winHeight - 100 + "px";
    // right.style.height = winHeight - 100 + "px";
  },
};
</script>

<style lang="scss" scoped="scoped">
.tips {
  padding-top: 20px;
  display: flex;
  color: rgba(0, 0, 0, 0.5);
  font-size: 0.16rem;
  line-height: 25px;
  padding-right: 20px;
  box-sizing: border-box;
}

div.addwork {
  div.contentWidth {
    margin: 0 auto;
    padding-bottom: 100px;
  }
  div.location {
    height: 40px;
    line-height: 40px;

    color: rgba(0, 0, 0, 0.25);
    font-size: 0.12rem;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
    cursor: pointer;

    a,
    span {
      // padding: 0 10px;
      // font-size: 14px;
      // color: #666;

      font-size: 0.12rem;
      color: rgba(0, 0, 0, 0.25);
      height: 0.2rem;
      line-height: 0.2rem;
      margin-top: 0.2rem;
    }
  }
  div.left {
    background: #fff;
    margin-right: 386px;
    height: 800px;
    overflow-y: auto;
    position: relative;
    padding-bottom: 100px;
    div.location {
      width: 600px;
      margin: 0 auto;
      height: 40px;
      line-height: 40px;
      color: #888;
      a,
      span {
        padding: 0 10px;
        font-size: 14px;
        color: #666;
      }
    }
    div.entry {
      width: 600px;
      margin: 0 auto;
      margin-top: 20px;
      input {
        display: block;
        width: 100%;
        height: 40px;
        line-height: 40px;
        border: 0;
        background: none;
        color: #222;
        font-size: 22px;
        padding: 0 5px;
      }
      textarea {
        width: 100%;
        min-height: 60px;
        line-height: 20px;
        font-size: 14px;
        border: 1px #fff solid;
        color: #676767;
        padding: 0 5px;
        border: 0;
        background: none;
      }
      input::-webkit-input-placeholder {
        color: #b1b4b7;
        font-size: 22px;
      }
      textarea::-webkit-input-placeholder {
        color: #c3c3c3;
        font-size: 14px;
      }
    }
    div.uploadfile {
      width: 40px;
      padding: 20px 0;
      position: fixed;
      top: 200px;
      left: 50%;
      z-index: 99;
      margin-left: -600px;
      button {
        display: block;
        width: 40px;
        height: 40px;
        background: #fff;
        cursor: pointer;
        border: 1px #ddd solid;
        border-radius: 20px;
        position: relative;
        margin-top: 15px;
        transition: all 0.3s;
        img {
          display: block;
          width: 20px;
          height: 20px;
          margin: 0 auto;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          cursor: pointer !important;
        }
        input {
          display: block;
          width: 40px;
          height: 40px;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 10;
          opacity: 0;
          cursor: pointer;
        }
      }
    }
    .uploadfile button:hover {
      cursor: pointer;
    }
    div.files {
      div.box {
        width: 600px;
        margin: 0 auto;
        position: relative;
        margin-top: 20px;
        padding-bottom: 20px;
        img {
          display: block;
          width: 600px;
        }
        div.entry {
          padding: 0;
          margin-top: 10px;
          textarea {
            width: 590px;
            height: 60px;
            padding: 5px;
            line-height: 20px;
            font-size: 14px;
            border-radius: 4px;
            border: 1px #eee solid;
            color: #676767;
          }
        }
        div.deleteBtn {
          position: absolute;
          top: 20px;
          right: 20px;
          display: block;
          width: 40px;
          height: 40px;
          line-height: 40px;
          cursor: pointer;
          text-align: center;
          background: rgba(0, 0, 0, 0.6);
          color: #fff;
          font-size: 22px;
          border-radius: 50%;
        }
        div.deleteBtn:hover {
          background: rgba(255, 0, 0, 0.9);
        }
      }
      div.box:nth-of-type(1) {
        margin-top: 0;
      }
    }
  }
  div.right {
    width: 385px;
    min-height: 900px;
    background: #fff;
    position: relative;
    div.title {
      height: 30px;
      line-height: 30px;
      font-size: 15px;
      padding-left: 5px;
    }
    div.entry {
      width: 100%;
      img {
        display: block;
        width: 20px;
        height: 20px;
        margin: 10px 0 0 10px;
        cursor: pointer;
      }
      img:hover {
        opacity: 1;
      }
    }
    div.addworkbtn {
      width: 100%;
      border-top: 1px #ddd solid;
      position: absolute;
      bottom: 100px;
      left: 0;
      div.of_h {
        width: 300px;
        margin: 0 auto;
        margin-top: 20px;
        button {
          width: 139px;
          height: 48px;
          line-height: 48px;
          border: 1px #fff solid;
          font-size: 14px;
          text-align: center;
          border-radius: 24px;
        }
        button.b1 {
          background: #d4011a;
          color: #fff;
        }
        button.b2 {
          background: #fff;
          border: 1px #d4011a solid;
          color: #d4011a;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/community/circle/addWork.vue